<script lang="ts">
  import type { PlayerView } from '@banger/shared';
  import HowToPlayLink from '../shared/HowToPlayLink.svelte';
  import Avatar from '../shared/Avatar.svelte';

  let { view }: { view: PlayerView } = $props();
  const me = $derived(view.players.find((p) => p.id === view.me.id));
</script>

<main>
  <h1 class="wordmark">BANGER!</h1>
  <h2>You're in!</h2>
  {#if me}
    <div class="me"><Avatar emoji={me.emoji} size={96} /><span class="name">{me.name}</span></div>
  {/if}
  <p class="wait">Waiting for the host to start…</p>
  <p class="count">{view.players.length} {view.players.length === 1 ? 'player' : 'players'} in the room</p>
  <HowToPlayLink backLabel="← Back to lobby" />
</main>

<style>
  main { min-height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1rem; padding: 24px 16px; text-align: center; }
  h1 { margin: 0; font-size: 2.6rem; }
  h2 { margin: 0; font-size: 2rem; color: var(--cyan); text-shadow: 0 0 14px rgba(125, 249, 255, 0.6); }
  .me { display: flex; flex-direction: column; align-items: center; gap: 10px; }
  .name { font-size: 1.8rem; font-weight: 800; word-break: break-word; }
  .wait { font-size: 1.2rem; margin: 0; animation: pulse 2s ease-in-out infinite; }
  .count { margin: 0; opacity: 0.7; }
  @keyframes pulse { 50% { opacity: 0.45; } }
</style>
